export const categoryLabelsMultipleEN: { [id: number]: string[] } = []
categoryLabelsMultipleEN[0] = ['Straight', ' Forward']
categoryLabelsMultipleEN[1] = ['Data', ' Manipulation']
categoryLabelsMultipleEN[2] = ['String', ' Manipulation']
categoryLabelsMultipleEN[3] = ['String ', 'Parsing']
categoryLabelsMultipleEN[4] = ['Simulation']
categoryLabelsMultipleEN[5] = ['Puzzle']
categoryLabelsMultipleEN[6] = ['Geometry']
categoryLabelsMultipleEN[7] = ['Numerical', ' Analysis']
categoryLabelsMultipleEN[8] = ['Ad Hoc', ' Mathmatics']
categoryLabelsMultipleEN[9] = ['Number']
categoryLabelsMultipleEN[10] = ['Graph']
categoryLabelsMultipleEN[11] = ['Game']
categoryLabelsMultipleEN[12] = ['Combinatorial ', 'Problem']
categoryLabelsMultipleEN[13] = ['Probability']

categoryLabelsMultipleEN[100] = ['Ordering']
categoryLabelsMultipleEN[110] = ['Searching']
categoryLabelsMultipleEN[200] = ['Brute ', 'Force']
categoryLabelsMultipleEN[210] = ['Backtracking']
categoryLabelsMultipleEN[220] = ['Heuristic', ' Search']
categoryLabelsMultipleEN[300] = ['Divide ', 'and', ' Conquer']
categoryLabelsMultipleEN[310] = ['Dynamic', ' Programming']
categoryLabelsMultipleEN[320] = ['Greedy ', 'Methods']
categoryLabelsMultipleEN[330] = ['Randomized ', 'Algorithm']
categoryLabelsMultipleEN[400] = ['Graph', ' Algorithms']
categoryLabelsMultipleEN[410] = ['Flow', ' Algorithms']
categoryLabelsMultipleEN[420] = ['Algorithm', ' with', ' Numbers']
categoryLabelsMultipleEN[430] = ['Numerical ', 'Algorithms']
categoryLabelsMultipleEN[440] = ['Geometric ', 'Algorithms']
categoryLabelsMultipleEN[450] = ['String', ' Algorithms']
categoryLabelsMultipleEN[500] = ['List']
categoryLabelsMultipleEN[510] = ['Hash']
categoryLabelsMultipleEN[520] = ['Set']
categoryLabelsMultipleEN[530] = ['Tree']

categoryLabelsMultipleEN[1000] = ['Sequential', ' Processing']
categoryLabelsMultipleEN[1100] = ['Branch']
categoryLabelsMultipleEN[1200] = ['Loop']
categoryLabelsMultipleEN[1300] = ['Loop', ' Control']
categoryLabelsMultipleEN[1400] = ['Structured ', 'Programming']
categoryLabelsMultipleEN[2000] = ['Variable']
categoryLabelsMultipleEN[2100] = ['Type']
categoryLabelsMultipleEN[2200] = ['Array']
categoryLabelsMultipleEN[2300] = ['Class']
categoryLabelsMultipleEN[3000] = ['Arithmetic', ' Operation']
categoryLabelsMultipleEN[3100] = ['Comparative ', 'Operation']
categoryLabelsMultipleEN[3200] = ['Logical ', 'Operation']
categoryLabelsMultipleEN[3300] = ['Advanced ', 'Operation']
categoryLabelsMultipleEN[3400] = ['Function']
categoryLabelsMultipleEN[4000] = ['Input']
categoryLabelsMultipleEN[4100] = ['Output']

export const categoryLabelsMultipleJP: { [id: number]: string[] } = []
categoryLabelsMultipleJP[0] = ['標準']
categoryLabelsMultipleJP[1] = ['データ']
categoryLabelsMultipleJP[2] = ['文字列操作']
categoryLabelsMultipleJP[3] = ['文字列解析']
categoryLabelsMultipleJP[4] = ['シミュレーション']
categoryLabelsMultipleJP[5] = ['パズル']
categoryLabelsMultipleJP[6] = ['幾何学']
categoryLabelsMultipleJP[7] = ['数値解析']
categoryLabelsMultipleJP[8] = ['アドホック']
categoryLabelsMultipleJP[9] = ['数字']
categoryLabelsMultipleJP[10] = ['グラフ']
categoryLabelsMultipleJP[11] = ['ゲーム']
categoryLabelsMultipleJP[12] = ['組み合わせ']
categoryLabelsMultipleJP[13] = ['確率']

categoryLabelsMultipleJP[100] = ['整列']
categoryLabelsMultipleJP[110] = ['探索']
categoryLabelsMultipleJP[200] = ['ブルートフォース']
categoryLabelsMultipleJP[210] = ['バックトラッキング']
categoryLabelsMultipleJP[220] = ['ヒューリスティック']
categoryLabelsMultipleJP[300] = ['分割統治法']
categoryLabelsMultipleJP[310] = ['動的計画法']
categoryLabelsMultipleJP[320] = ['貪欲法']
categoryLabelsMultipleJP[330] = ['ランダム']
categoryLabelsMultipleJP[400] = ['グラフ']
categoryLabelsMultipleJP[410] = ['フロー']
categoryLabelsMultipleJP[420] = ['数値']
categoryLabelsMultipleJP[430] = ['数値計算']
categoryLabelsMultipleJP[440] = ['幾何']
categoryLabelsMultipleJP[450] = ['文字列']
categoryLabelsMultipleJP[500] = ['リスト']
categoryLabelsMultipleJP[510] = ['ハッシュ']
categoryLabelsMultipleJP[520] = ['集合']
categoryLabelsMultipleJP[530] = ['木']

categoryLabelsMultipleJP[1000] = ['逐次']
categoryLabelsMultipleJP[1100] = ['分岐']
categoryLabelsMultipleJP[1200] = ['繰り返し']
categoryLabelsMultipleJP[1300] = ['繰り返し制御']
categoryLabelsMultipleJP[1400] = ['構造化']
categoryLabelsMultipleJP[2000] = ['変数']
categoryLabelsMultipleJP[2100] = ['型']
categoryLabelsMultipleJP[2200] = ['配列']
categoryLabelsMultipleJP[2300] = ['クラス']
categoryLabelsMultipleJP[3000] = ['演算']
categoryLabelsMultipleJP[3100] = ['比較']
categoryLabelsMultipleJP[3200] = ['論理']
categoryLabelsMultipleJP[3300] = ['高度演算']
categoryLabelsMultipleJP[3400] = ['関数']
categoryLabelsMultipleJP[4000] = ['入力']
categoryLabelsMultipleJP[4100] = ['出力']
